import request from '@/utils/request';

export default {
    getItems: async({ dispatch, commit }, { fetchAll = false, ...params }) => {
        const url = fetchAll ? '/forms/all' : '/forms';
        const requestOptions = {
            url
        };

        if (!fetchAll) {
            Object.assign(requestOptions, { params });
        }

        await request({ ...requestOptions })
            .then(res => {
                if (res.data) {
                    commit('PROCESS_RES', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    destroy: async({ dispatch }, id) => {
        await request({
            method: 'delete',
            url: `/forms/${id}`
        }).then(res => {
            if (res.status == 204) {
                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }
        }).catch(error => {
            if(error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    }
};
